import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SystemHealthPage } from "@charphq/ui/components/health/system-health-page";

type Search = {
  view?: "devices" | "deployments" | "projects" | "customers" | "changes";
  status?: "healthy" | "warning" | "critical";
  issue?: "stale_data" | "low_battery" | "weak_signal" | "gateway_offline" | "weak_backhaul";
  deviceRole?: string;
  customerId?: string;
  projectId?: string;
  deploymentId?: string;
  muted?: "true" | "false";
  q?: string;
  page?: number;
  limit?: number;
  // Comparison window for the Changes (A-vs-B delta) view, as ISO instants.
  deltaFrom?: string;
  deltaTo?: string;
  // Which window control is active, so the highlight survives reload and sharing.
  deltaPreset?: "checkpoint" | "24h" | "7d" | "custom";
};

export const Route = createFileRoute("/system-health")({
  component: SystemHealthRoute,
  validateSearch: (search: Record<string, unknown>): Search => ({
    view: search.view as Search["view"],
    status: search.status as Search["status"],
    issue: search.issue as Search["issue"],
    deviceRole: search.deviceRole as string | undefined,
    customerId: search.customerId as string | undefined,
    projectId: search.projectId as string | undefined,
    deploymentId: search.deploymentId as string | undefined,
    muted: search.muted as Search["muted"],
    q: search.q as string | undefined,
    page: search.page ? Number(search.page) : undefined,
    limit: search.limit ? Number(search.limit) : undefined,
    deltaFrom: search.deltaFrom as string | undefined,
    deltaTo: search.deltaTo as string | undefined,
    deltaPreset: search.deltaPreset as Search["deltaPreset"],
  }),
});

function SystemHealthRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  return (
    <SystemHealthPage
      searchParams={search}
      onParamsChange={(next) => navigate({ to: "/system-health", search: next, replace: true })}
    />
  );
}
